<template>
  <div class="account-auth-form-content">
    <div class="old-mb-4">
      <ValidationProvider
        name="email"
        rules="required|email"
        v-slot="{ errors }"
        mode="eager"
        slim
      >
        <text-input
          name="customer[email]"
          type="email"
          v-model="email"
          label="Email"
          :error="errors && errors[0]"
        />
      </ValidationProvider>
    </div>

    <div style="margin-bottom: 8px">
      <ValidationProvider
        name="password"
        rules="required|min:6"
        v-slot="{ errors }"
        mode="eager"
        slim
      >
        <text-input
          name="customer[password]"
          type="password"
          v-model="password"
          label="Password"
          :error="errors && errors[0]"
        />
      </ValidationProvider>
    </div>

    <div
      @click="showRecoverPasswordForm"
      class="old-mb-6 account-forgot-password"
    >
      Forgot your password?
    </div>

    <input class="submit-button plaid-l fs-12" type="submit" value="SIGN IN" />
  </div>
</template>

<script>
export default {
  name: "login-form",
  data() {
    return {
      email: "",
      password: "",
    };
  },
  methods: {
    showRecoverPasswordForm() {
      const loginContainer = document.querySelector(".account-auth-login");
      const recoverPasswordContainer = document.querySelector(
        ".account-auth-recover-password"
      );

      loginContainer.style.display = "none";
      recoverPasswordContainer.style.display = "block";
    },
  },
  mounted() {
    const url = new URL(window.location);
    if (url.pathname === "/account/login") {
      var el = document.querySelector(
        '#customer_login input[name="return_url"]'
      );
      if (!el) return;
      var [path, originalParams] = el.value.split("?");
      let newParams = new URLSearchParams(originalParams);
      newParams.set("from_login", true);
      el.value = `${path}?${newParams}`;
    }
  },
};
</script>
